function debounce (func, delay) {
    let inDebounce
    return function () {
        clearTimeout(inDebounce)
        inDebounce = setTimeout(function () {
            func()
        }, delay)
    }
}

export default {
    methods: {
        debounce
    }
}
